import {withNamespaces} from "react-i18next";
import React, {useContext} from "react";
import PropTypes from "prop-types";
import {AuthContext} from "../../member/components/AuthContext";
import MoneyHelper from "../../../services/MoneyHelper";
import {CancellationPaymentTypes} from "../models/CancelDetails";

const ReduceRateAccepted = (props) => {
  return (
    <div>Reduce rate accepted!</div>
  );
};
ReduceRateAccepted.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
  member: PropTypes.object,
};
const DowngradeAccepted = (props) => {
  return (
    <div>Downgrade accepted!</div>
  );
};
DowngradeAccepted.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
  member: PropTypes.object,
};
const FreeAddonAccepted = (props) => {
  return (
    <div>Free addon accepted!</div>
  );
};
FreeAddonAccepted.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
  member: PropTypes.object,
};
const UpgradeAccepted = (props) => {
  return (
    <div>Upgrade accepted!</div>
  );
};
UpgradeAccepted.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
  member: PropTypes.object,
};

const CancellationAccepted = (props) => {
  const { t, member } = props;

  const isCooldown = props.cancelDetails.cancellation.isCooldownPeriod();
  const isPayNow = props.offerData.data.isPayNow
    ? props.offerData.data.isPayNow()
    : true;
  return (
    <React.Fragment>
      <div className='cancellation-confirmation-header'>
        <i className='fa fa-check-circle-o' />
        <h3>{t('cancellation_confirmation_success')}</h3>
        <p>{t(`cancellation_confirmation_success_text1${isCooldown ? '_cooldown' : ''}`, {club_name: member.club.name})}</p>
        {props.offerData.data.payment_type === CancellationPaymentTypes.Regular ? (
          <p>{t('cancellation_confirmation_success_text2_regular', {end_date: props.cancelDetails.cancellation.formattedActiveUntil()})}</p>
        ) : (
          <p>{t(`cancellation_confirmation_success_text2${isCooldown ? '_cooldown' : ''}`, {end_date: props.cancelDetails.cancellation.formattedActiveUntil()})}</p>
        )}
      </div>

      <div className="cancellation-confirmation-details">
        {member && <p dangerouslySetInnerHTML={{__html: t('cancellation_confirmation_email_sent', {email: member.email})}} />}
        <div>
          {[
            {name: 'cancellation_date', value: isCooldown ? t('cancellation_confirmation_date_pending') : new Date().toLocaleDateString()},
            {name: 'access_until', value: isCooldown ? t('cancellation_confirmation_access_until_refund') : props.cancelDetails.cancellation.formattedActiveUntil()},
            props.cancelDetails.cancellation.hasDues() ? {name: 'payment_amount', value: MoneyHelper.toPrice(props.cancelDetails.cancellation.getFinalAmount(isPayNow))} : null,
            props.cancelDetails.cancellation.hasDues() ? {name: 'payment_method', value: t('cancellation_confirmation_payment_card', {last_four: member.default_card.last_four})} : null,
          ].filter(a => !!a).map((item, index) => (
            <p key={index}>{t(`cancellation_confirmation_${item.name}`)}: <span className='bold'>{item.value}</span></p>
          ))}
        </div>
      </div>

      <div className='form-group additional-options'>
        {/*<div>*/}
        {/*  <p>{t('cancellation_confirmation_reactivate_info')}</p>*/}
        {/*  <button className='form-main-button white-with-border '>*/}
        {/*    {props.t('cancellation_confirmation_reactivate_cta')}*/}
        {/*  </button>*/}
        {/*</div>*/}
        <div>
          <p>{t('cancellation_confirmation_crunchplus_info')}</p>
          <button className='form-main-button white-with-border '>
            {props.t('cancellation_confirmation_crunchplus_cta')}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
CancellationAccepted.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
  member: PropTypes.object,
};

const CancellationConfirmation = (props) => {
  const { member } = useContext(AuthContext);

  const componentsMap = {
    'reduce_rate': ReduceRateAccepted,
    'downgrade': DowngradeAccepted,
    'free_addon': FreeAddonAccepted,
    'upgrade': UpgradeAccepted,
    'cancellation': CancellationAccepted,
  }
  const Component = componentsMap[props.offerData.accepted_offer];
  console.log('Cancel details', props.cancelDetails, props.offerData);

  return (
    <div className='cancellation-confirmation-container'>
      <Component {...props} member={member} />
    </div>
  );
};

CancellationConfirmation.propTypes = {
  cancelDetails: PropTypes.object,
  offerData: PropTypes.object,
}

export default withNamespaces()(CancellationConfirmation);
